'use strict'

import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js'
import { html } from '@polymer/polymer/lib/utils/html-tag.js'

import '@polymer/iron-ajax/iron-ajax'
import '@polymer/paper-toast/paper-toast'
import '@polymer/paper-button/paper-button'
import '@polymer/iron-flex-layout/iron-flex-layout-classes'

Polymer({
  is: 'moskito-cookie-consent',
  _template: html`
    <style>
    paper-toast {
      font-size: 1.1em;
      --paper-toast-background-color: rgba(38,50,56, 0.9);
      backdrop-filter: blur(3px);
      --webkit-backdrop-filter: blur(3px);
    }

    .alert-button {
      text-transform: none;
      float: right;
    }
    paper-toast {
      padding-left: 60px;
      padding-right: 60px;
    }
    </style>
    <paper-toast id="consentToast" class="fit-bottom" duration="0">
      <div class="horizontal">
        <div>
          <dom-if if="[[policyLink]]">
          <template is="dom-if">
            <a href$="[[policyLink]]" target$="[[policyTarget]]" class="policy-link">[[policyText]]</a>
          </template>
          </dom-if>
          <slot name="text"></slot>
          <slot name="policy-link"></slot>
        </div>
        <div>
          <paper-button id="acceptButton" on-tap="_respond" data-response="accept"><iron-icon icon="icons:check"></iron-icon>[[acceptText]]</paper-button>
        </div>
      </div>
    </paper-toast>
    `,
  properties: {
    cookiesStatus: {
      type: String,
      value: 'pending',
      readOnly: true,
      notify: true,
      reflectToAttribute: true
    },
    /**
     * Use the local storage instead of saving user cookie consent to a cookie.
     */
    useLocalStorage: Boolean,
    /**
     * Use the session storage instead of saving user cookie consent to a cookie.
     *
     * This can be useful to test out the cookie consent toast, as the user choice
     * will be deleted when he closes the browser tab.
     */
    useSessionStorage: Boolean,

    /**
     * The text displayed on the consent.
     */
    text: {
      type: String,
      value: 'Ce site internet utilise des cookies pour vous proposer une meilleure expérience de navigation.' // 'This website uses cookies to give you a better browsing experience.'
    },
    /**
     * The link to the cookie policy used by your website (if there is one).
     */
    policyLink: String,
    /**
     * The target for the cookie policy link used by your website (if there is one).
     */
    policyTarget: {
      type: String,
      value: '_self'
    },
    /**
     * The text to display on the link to the cookie policy.
     */
    policyText: {
      type: String,
      value: 'En savoir plus' // 'Learn more'
    },
    /**
     * The text to display on the button to accept the cookie policy.
     */
    acceptText: {
      type: String,
      value: "J'accepte" // 'Got it!'
    },
    /**
     * The text to display on the button to reject the cookie policy.
     *
     * Visible only if the cookie consent is also `rejectable`.
     */
    rejectText: {
      type: String,
      value: 'No, thanks'
    },
    /**
     * Seconds to wait before making the toast appear.
     */
    secondsBeforeAppearing: {
      type: Number,
      value: 0
    }
  },
  _respond: function (e) {
    var response = e.target.dataset.response

    // We got an invalid response
    if ((response !== 'accept') &&
        (response !== 'reject') &&
        (response !== 'true') &&
        (response !== 'false')) {
      console.error('Error: invalid response!')
      return
    }
    var answer = (response === 'accept') || (response === 'true');

    // Priority goes first to the session storage...
    if (this.useSessionStorage) {
      sessionStorage.setItem('acceptCookies', answer)
    }
    // ...then to the local storage...
    else if (this.useLocalStorage) {
      localStorage.setItem('acceptCookies', answer)
    }
    // ...and in the end, to the cookie
    else {
      document.cookie = 'acceptCookies=' + answer + '; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/'
    }
    // Update the cookie consent status
    this._setCookiesStatus(answer ? 'accepted' : 'rejected')
    // Close the toast
    this.$.consentToast.close()
  },
  _cookieVal: function () {
    return document.cookie.replace(/(?:(?:^|.*;\s*)acceptCookies\s*\=\s*([^;]*).*$)|^.*$/, '$1');
  },
  attached: function () {
    var cookie = this._cookieVal()
    // If the cookie exists
    if (cookie.length > 0) {
      // Set the correct status
      this._setCookiesStatus((cookie === 'true') ? 'accepted' : 'rejected')
    }
    // If there is no cookie, look in the local storage
    else if (localStorage.acceptCookies) {
      // Set the correct status
      this._setCookiesStatus((localStorage.getItem('acceptCookies') === 'true') ? 'accepted' : 'rejected')
    }
    // Last but not least, check in the session storage, even though we should not find it here
    else if (sessionStorage.acceptCookies) {
      // Set the correct status
      this._setCookiesStatus((sessionStorage.getItem('acceptCookies') === 'true') ? 'accepted' : 'rejected')
    }
    // If we cannot find the info anywhere, let's check the
    // user country to see if we need to display him the consent.
    else {
      this.$.consentToast.open()
    }
  }
})
